export default function($stateProvider) {
  'ngInject';

  $stateProvider.state('savedCards', {
    component: 'fizyPaycellSavedCards',
    parent: 'mainWrapper',
    url: '/saved-cards'
  });
}



// WEBPACK FOOTER //
// ./src/app/buy/saved-cards/saved-cards.routes.ts